module.exports = __webpack_public_path__ + "img/icon-git.a7cd80c8.svg";